import { useState } from "react";
import { Button, Flex, Tooltip } from "antd";
import { CheckOutlined } from "@ant-design/icons";

import { copyText } from "utils";
import { ReactComponent as CopyIcon } from "images/copy.svg";

import styles from "./copyableText.module.css";

export const CopyableText = ({ children }: { children?: string }) => {
  const [copied, setCopied] = useState(false);

  if (!children) return null;

  const handleCopy = async () => {
    copyText(children).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1000);
    });
  };

  return (
    <Flex gap="small" align="center">
      {children}
      <Button type="link" size="middle" onClick={handleCopy} className={`${styles.copyButton} copyIcon`}>
        <Tooltip title={copied ? "Скопировано" : "Копировать"}>
          {copied ? <CheckOutlined className={styles.checkIcon} /> : <CopyIcon className="copyIcon" />}
        </Tooltip>
      </Button>
    </Flex>
  );
};
